import { useGetIndividualCompanyDetailsQuery } from '@/app/globalRedux/api/individualCompanyService'
import { useTranslation } from '@/app/i18n/client'
import { CompanyDetails } from '@/app/types/individualCompanyProfile'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import Image from 'next/image'
import { useRef, useState } from 'react'

import { gtmAskQuoteFormSubmission } from '@/app/[lng]/components/GTMTrackers/GTMCompanyTracker'
import { Textarea } from '@/components/ui/textarea'
import { askQuote } from '@/services/companyDetailsService'
import { useParams } from 'next/navigation'
import { toast } from 'sonner'
const AskQuote = ({ productId }: { productId: number }) => {
  const { t } = useTranslation()
  const params = useParams()
  const { data } = useGetIndividualCompanyDetailsQuery<{
    data: CompanyDetails
    isError: boolean
  }>(String(params?.id))
  const [quoteMessage, setQuoteMessage] = useState<string>('')
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [formSumbitted, setFormSubmitted] = useState<boolean>(false)
  const textareaRef = useRef<any>(null)
  const askQuoteController = () => {
    setQuoteMessage('')
    setOpenModal(!openModal)
    if (!openModal) {
      setFormSubmitted(false)
    }
  }

  const handleParagraphClick = () => {
    if (textareaRef?.current) {
      textareaRef?.current?.focus()
    }
  }

  const handleQuoteSubmit = async () => {
    setFormSubmitted(true)
    if (quoteMessage?.length == 0) {
      return
    }
    const response: { message: string; status: string } = await askQuote(
      String(params?.id),
      productId,
      quoteMessage
    )
    setFormSubmitted(false)
    setOpenModal(false)
    if (response?.status == 'success') {
      gtmAskQuoteFormSubmission(String(params?.id), productId, data?.company?.id)
      toast.success(t('Quote request sent successFully'))
    } else if (response.status == 'error') {
      toast.error(t('Error in sending Quote request'))
    }
  }

  const askQuoteErrorMessage = (message: string, sumbitted: boolean) => {
    return message.length == 0 && sumbitted
  }

  return (
    <Dialog open={openModal} onOpenChange={askQuoteController}>
      <DialogTrigger>
        <Button
          variant="secondary"
          size="sx"
          className="px-2 py-1 flex w-[100%]"
        >
          {t('Ask Quote')}
        </Button>
      </DialogTrigger>

      <DialogContent className="!max-w-[940px] overflow-y-scroll max-h-[90vh]">
        <DialogHeader className="">
          <DialogTitle className="bg-modal_header px-8 py-4 tracking-wide flex items-center gap-8  ">
            {t('Ask Quote')}
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col">
          <p className="!px-[8%] mt-[18px]">{'Message'}</p>
          <div className="!px-[8%] py-[18px]  ">
            <div className="rounded !border-2 !border-[#e0e0e0] p-2 ">
              <span onClick={handleParagraphClick}>
                <p className="text-sm font-semibold">
                  {t('Hey')} {data?.company?.name},
                </p>
              </span>
              <Textarea
                maxLength={600}
                aria-label="quote-message"
                rows={3}
                onChange={(e) => {
                  setQuoteMessage(e.target.value)
                }}
                ref={textareaRef}
                placeholder={`${t('Enter your message')}...`}
                className="!border-none  !px-[0] !py-[10px]"
              />
            </div>
            <span className=" flex flex-row">
              <span className=" flex flex-row ml-auto">
                <span className=" required"></span>
                <p className=" text-sm ml-1">
                  {600 - quoteMessage.length} {t('characters left')}
                </p>
              </span>
            </span>
            {askQuoteErrorMessage(quoteMessage, formSumbitted) && (
              <span className="text-required_color text-xs">
                {t('Please enter the message before submission')}
              </span>
            )}
          </div>

          <DialogFooter>
            <Button
              size="icon"
              variant="secondary"
              onClick={() => {
                handleQuoteSubmit()
              }}
            >
              <Image
                alt="send"
                src={'/assets/Icons/sendIcon.svg'}
                height={14.2}
                width={14.2}
              />
              {t('SEND MESSAGE')}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default AskQuote
